
import { useState, useEffect } from "react"
import "../Css_files/Mou.css"
import Footer from "./Footer"
import Navbar from "./Navbar"

const Mou = () => {
  const [activeIndex, setActiveIndex] = useState(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  // Sample MOU data - replace with your actual data
  const mouData = [
    {
      id: 1,
      collegeName: "Engineering College of Excellence",
      date: "January 15, 2023",
      description: "Partnership for technical education and research collaboration",
      image: "/placeholder.svg?height=400&width=600&text=Engineering+College+MOU",
    },
    {
      id: 2,
      collegeName: "Business Management Institute",
      date: "March 22, 2023",
      description: "Joint program for entrepreneurship development",
      image: "/placeholder.svg?height=400&width=600&text=Business+Management+MOU",
    },
    {
      id: 3,
      collegeName: "Medical Sciences University",
      date: "May 10, 2023",
      description: "Collaboration for healthcare innovation projects",
      image: "/placeholder.svg?height=400&width=600&text=Medical+Sciences+MOU",
    },
    {
      id: 4,
      collegeName: "Arts & Design Academy",
      date: "July 5, 2023",
      description: "Creative industry partnership for student projects",
      image: "/placeholder.svg?height=400&width=600&text=Arts+Design+MOU",
    },
    {
      id: 5,
      collegeName: "Technology Institute",
      date: "September 18, 2023",
      description: "Joint research initiatives in emerging technologies",
      image: "/placeholder.svg?height=400&width=600&text=Technology+Institute+MOU",
    },
    {
      id: 6,
      collegeName: "Agricultural Sciences College",
      date: "November 30, 2023",
      description: "Sustainable farming practices research collaboration",
      image: "/placeholder.svg?height=400&width=600&text=Agricultural+Sciences+MOU",
    },
  ]

  const handleMouseEnter = (index) => {
    setActiveIndex(index)
  }

  const handleMouseLeave = () => {
    setActiveIndex(null)
  }

  return (
    <>
    <Navbar/><br></br><br></br><br></br>
    <div className={`mou-showcase-container ${isVisible ? "visible" : ""}`}>
      <header className="mou-header">
        <h1>Our Academic Partnerships</h1>
        <p>
          We have established strong collaborations with leading educational institutions through these Memorandums of
          Understanding
        </p>
      </header>

      {/* <div className="mou-stats">
        <div className="stat-item">
          <span className="stat-number">{mouData.length}</span>
          <span className="stat-label">Partner Institutions</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">5+</span>
          <span className="stat-label">Years of Collaboration</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">50+</span>
          <span className="stat-label">Joint Projects</span>
        </div>
      </div> */}

      <div className="mou-grid">
        {mouData.map((mou, index) => (
          <div
            key={mou.id}
            className={`mou-card ${activeIndex === index ? "active" : ""}`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div className="mou-image-container">
              <img src={mou.image || "/placeholder.svg"} alt={`MOU with ${mou.collegeName}`} className="mou-image" />
              <div className="mou-overlay">
                <h3>{mou.collegeName}</h3>
                <p className="mou-date">{mou.date}</p>
                <p className="mou-description">{mou.description}</p>
              </div>
            </div>
            <div className="mou-info">
              <h3>{mou.collegeName}</h3>
              <p>{mou.date}</p>
            </div>
          </div>
        ))}
      </div>

      <section className="trust-section">
        <h2>Why Partner With Us?</h2>
        <div className="trust-points">
          <div className="trust-point">
            <div className="trust-icon">🤝</div>
            <h3>Proven Track Record</h3>
            <p>
              Our partnerships have resulted in successful joint initiatives and projects that benefit students and
              faculty alike.
            </p>
          </div>
          <div className="trust-point">
            <div className="trust-icon">🎓</div>
            <h3>Educational Excellence</h3>
            <p>
              We are committed to maintaining the highest standards of educational quality in all our collaborative
              efforts.
            </p>
          </div>
          <div className="trust-point">
            <div className="trust-icon">💡</div>
            <h3>Innovation Focus</h3>
            <p>
              Our partnerships drive innovation through research, development, and practical applications in various
              fields.
            </p>
          </div>
        </div>
      </section>

      <footer className="mou-footer">
        <p>Interested in establishing a partnership with us? Contact our academic relations team today.</p>
        <button className="contact-button">Contact Us</button>
      </footer>
    </div>
    <Footer/>
    </>
  )
}

export default Mou
